import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { ComponentType, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Application, COLORS } from 'src/components/applications/applications-user/BasicTable';
import { Page } from 'src/components/page';
import { ApiAppeal, ApiApplication } from 'src/http';

// interface Appeal {
//   id: number;
//   uid: string;
//   prevUid: null;
//   taskId: string;
//   additional: null;
//   employeeData: null;
//   declineReason: null;
//   status: 'DECLINED';
//   attestationStatus: null;
//   appealStatus: 'PENDING';
//   appealDescription: 'string';
//   appealConfirmDescription: null;
//   appealConfirmAt: null;
//   appealDeclinedReason: null;
//   appealDeclinedAt: null;
//   startedAt: null;
//   stoppedReason: null;
//   absentReason: null;
//   confirmedAt: '2023-08-29T06:26:44.188Z';
//   declinedAt: null;
//   completedAt: null;
//   attestationDate: null;
//   score: 0;
//   isPassed: null;
//   isPrimary: null;
//   isWarned: null;
//   isDetermineByMe: null;
//   language: null;
//   previewLanguage: null;
//   appFrom: 'attestat_local';
//   indPhone: null;
//   certificate: null;
//   specialtiesDocument: null;
//   internationalCertificate: null;
//   correctAnswersCount: null;
//   questionsCount: null;
//   appType: '2';
//   workplace: 'elektron';
//   position: 'asdadwad';
//   specialty: 'asdawdw';
//   hisSpecialty: 'qwqeqweqwe';
//   nameMedicalEducational: 'dasdqwdqwdwq';
//   copyDiploma: 'lcr9kLWScreenShot20230803at02.42.58.png';
//   qualificationCategory: '0';
//   qualificationCategoryIssued: 'dasd asd qualificationCategoryIssued';
//   qualificationCategorySpecialty: 'das sad squalificationCategorySpecialty';
//   copyQualificationCategory: null;
//   creditAccumulated: '122';
//   copyCertificateQualification: 'thb2bhLWScreenShot20230803at02.42.58.png';
//   workExperienceYear: '123';
//   specialtyWorkExperience: '123';
//   claimedQualification: '1';
//   electronicWorkBook: 'qnwh2LWScreenShot20230803at02.42.58.png';
//   attestationResult: null;
//   certSeriesNumber: null;
//   commandYear: null;
//   commandDay: null;
//   commandMonth: null;
//   commandNumber: null;
//   skillCategoryType: null;
//   givenYear: null;
//   givenDay: null;
//   givenMonth: null;
//   validityYear: null;
//   validityDay: null;
//   validityMonth: null;
//   medData: {
//     region: 10;
//     appType: '2';
//     position: 'asdadwad';
//     specialty: 'asdawdw';
//     workplace: 'elektron';
//     commission: 2;
//     copyDiploma: 'lcr9kLWScreenShot20230803at02.42.58.png';
//     hisSpecialty: 'qwqeqweqwe';
//     specialization: 10;
//     creditAccumulated: '122';
//     electronicWorkBook: 'qnwh2LWScreenShot20230803at02.42.58.png';
//     workExperienceYear: '123';
//     claimedQualification: '1';
//     qualificationCategory: '0';
//     nameMedicalEducational: 'dasdqwdqwdwq';
//     specialtyWorkExperience: '123';
//     qualificationCategoryIssued: 'dasd asd qualificationCategoryIssued';
//     copyCertificateQualification: 'thb2bhLWScreenShot20230803at02.42.58.png';
//     qualificationCategorySpecialty: 'das sad squalificationCategorySpecialty';
//   };
//   invoice: null;
//   xabar: null;
//   createdAt: '2023-08-25T09:36:22.818Z';
//   updatedAt: '2023-08-31T10:32:15.934Z';
//   deletedAt: null;
//   user: 4;
//   organization: null;
//   direction: null;
//   region: 10;
//   district: null;
//   confirmedBy: 5;
//   declinedBy: null;
//   appealConfirmedBy: null;
//   appealDeclinedBy: null;
//   startedBy: null;
//   attestationLocation: null;
//   questions: [];
//   commission: 2;
//   specialization: 10;
//   userId: 4;
//   organizationId: null;
//   directionId: null;
//   regionId: 10;
//   districtId: null;
//   startedById: null;
//   commissionId: 2;
//   specializationId: 10;
// }

export const AppealsUser: ComponentType = () => {
  const { t } = useTranslation();

  const [applicationId, setApplicationId] = useState<undefined | null | string>('');
  const [applications, setApplications] = useState<Application[] | null>(null);
  const [message, setMessage] = useState<string>('');

  const getApplications = async () => {
    let params = {
      skip: 0,
      take: 100,
    };
    try {
      const data = await ApiApplication.fetchAll(params);
      setApplications(data.hits);
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  const [appeals, setAppeals] = useState<any[] | null>(null);
  const getAppeals = async () => {
    let params = {
      skip: 0,
      take: 100,
    };
    try {
      const data = await ApiAppeal.fetchAll(params);
      setAppeals(data.hits);
      reset();
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  const createApplication = async () => {
    try {
      await ApiAppeal.createOne({
        application: applicationId,
        description: message,
      });
      getAppeals();
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  const reset = () => {
    setMessage('');
    setApplicationId('');
  };

  useEffect(() => {
    getAppeals();
    getApplications();
  }, []);

  return (
    <Page title={t('appeal', 'Апелляция')}>
      {/* <br /> */}
      {appeals ? (
        <Box bgcolor={'#fff'} p={2} borderRadius={2}>
          <Typography variant="h2" mb={2.25}>
            {t('appeals', 'Подача апелляции')}
          </Typography>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{t('ID')}</TableCell>
                  <TableCell align="right">{t('status')}</TableCell>
                  <TableCell align="right">{t('appeal')}</TableCell>
                  <TableCell align="right">{t('description')}</TableCell>
                  {/* <TableCell align="right">Carbs&nbsp;(g)</TableCell>
                  <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {appeals?.map((a: any) => (
                  <TableRow key={a.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell component="th" scope="row">
                      {a.id}
                    </TableCell>
                    <TableCell align="right">
                      <Box
                        component={'span'}
                        bgcolor={COLORS[a.appealStatus]}
                        color={'#fff'}
                        py={1}
                        px={1}
                        borderRadius={1}
                      >
                        {t('appealStatus.' + a.appealStatus)}
                      </Box>
                    </TableCell>
                    <TableCell align="right">
                      {t(
                        [
                          'Врачлар ва фармацевтлар',
                          '“Олий ҳамширалик иши” мутахассислигига эга бўлган ҳамширалар, ўрта тиббиёт ва ўрта фармацевтика ходимлари',
                          'Бирламчи тиббиёт ходимлари',
                        ][Number(a.appType) - 1]
                      )}
                    </TableCell>
                    <TableCell align="right">{a.appealDescription}</TableCell>
                    {/* <TableCell align="right">{a.medData.specialty}</TableCell>
                    <TableCell align="right">{a.medData.specialty}</TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : null}
      <Box bgcolor={'#fff'} p={2} borderRadius={2} mt={6}>
        <Typography variant="h2" mb={2.25}>
          {t('appeals.create', 'Подача апелляции')}
        </Typography>
        <FormControl
          sx={{
            mt: 3,
          }}
          fullWidth
        >
          <InputLabel id="demo-simple-select-label">{t('applications')}</InputLabel>
          <Select
            required
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={applicationId}
            label="Age"
            onChange={(e) => {
              setApplicationId(e.target.value);
            }}
          >
            {applications?.map((c: Application) => (
              <MenuItem value={c.id} key={c.id}>
                {t(
                  [
                    'Врачлар ва фармацевтлар',
                    '“Олий ҳамширалик иши” мутахассислигига эга бўлган ҳамширалар, ўрта тиббиёт ва ўрта фармацевтика ходимлари',
                    'Бирламчи тиббиёт ходимлари',
                  ][Number(c.appType) - 1]
                )}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            mt: 3,
          }}
          fullWidth
        >
          <TextField
            id="outlined-multiline-static"
            label={t('appeal.explanationNotAgree')}
            multiline
            rows={4}
            defaultValue={''}
            value={message}
            inputProps={{ maxLength: 250 }}
            onChange={(e) => {
              setMessage(e.target.value);
            }}
          />
        </FormControl>
        <Box display="flex" justifyContent={'flex-end'} my={2}>
          <Button
            onClick={createApplication}
            variant="outlined"
            size="large"
            disabled={message === ''}
          >
            {t('action.save')}
          </Button>
        </Box>
      </Box>
    </Page>
  );
};
